import * as React from "react"
import {Helmet} from "react-helmet"
import metaImage from '/static/dynamicmeta.jpg'


const SEO = ({title}) => {
    let url = ''
    if (typeof window !== 'undefined') {
        url = window?.location?.href
    }


    function stripTrailingSlash(str) {
        return str.replace(/\/$/, ''); // Replace trailing slash with an empty string
    }

    return (
        <Helmet htmlAttribute={{lang: "en"}} title={`${title} | Dynamic Web Partners`}>
            <meta name="description"
                  content={'Dynamic Web Partners - Your gateway to a powerful online presence. Offering customized comprehensive website services. Discover how we can transform your digital journey and amplify your brand today.'}/>
            <meta name="image" content={`${stripTrailingSlash(url)}${metaImage}`}/>
            {/* Facebook Card */}
            <meta property="og:url" content={'www.dynamicwebpartners.com'}/>
            <meta property="og:type" content="website"/>
            <meta property="og:title" content={`${title} | Dynamic Web Partners`}/>
            <meta property="og:description"
                  content={'Dynamic Web Partners - Your gateway to a powerful online presence. Offering customized comprehensive website services. Discover how we can transform your digital journey and amplify your brand today.'}/>
            <meta property="og:image" content={`${stripTrailingSlash(url)}${metaImage}`}/>
            <meta property="og:image" content="400"/>
            <meta property="og:image:height" content="300"/>

            {/* Twitter Card */}
            <meta name="twitter:card" content="summary_large_image"/>
            {/*<meta name="twitter:creator" content={twitterUsername}/>*/}
            {/*<meta name="twitter:title" content={siteTitle}/>*/}
            {/*<meta name="twitter:description" content={siteDesc}/>*/}
            <meta name="twitter:image" content={metaImage}/>
        </Helmet>
    )
}

export default SEO
